import React from 'react'
import Svg from './Svg'
export const SvgReports = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M4.928 0v3.001H1.927v21.005h17.005v-3.001h3V0H4.929zm12.003 22.007H3.928V5.002h1v16.004h12.004v1h-.001zm3.001-3.002H6.929V2.001h13.003v17.004zm-5-14.003H8.93v2.001h6.001v-2zm2.999 3H8.929v1h9.002v-1zm0 2H8.929v1.001h9.002v-1zm0 2.002H8.929v1h9.002v-1zm-6.001 2H8.929v1.001h3.001v-1z" />
  </Svg>
))
SvgReports.isIcon = true
export default SvgReports
